const constants = {
    S3_URL: 'https://descendants-cdn.chainsaw.fun',
    IPFS_URL: 'https://cloudflare-ipfs.com/ipfs/',  // todo: change
    // IPFS_URL: 'https://chainsaw.mypinata.cloud/ipfs/',
    PAINTING_ADDON_ID: '7',
    PAINTING_HOBBY_ATTRIBUTE: 'Painting',
};

export default constants;